import { css } from 'react-emotion'
import 'animate.css/animate.min.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export default css`
  html {
    scroll-behavior: smooth;
  }
  body {
    font-family: 'Gothic A1', sans-serif;
    width: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    background-color: #000;
    @media  (min-width: 1900px) {
      font-size: 1.8rem;
    }
  }

  a {
    color: inherit;
    text-decoration: none;


    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }
  .content {
  }
  .no-padding {
    padding-left: 0;
    padding-right: 0;
  }
  .logo {
    height: 1.5em;
  }
  .bg-semi-dark {
    background-color: rgba(33, 35, 37, 0.5);
    transition: background-color cubic-bezier(0.075, 0.82, 0.165, 1);
    &.scrolled {
      background-color: rgba(80, 35, 37, 0.9);
      /* padding-top:1em; */
    }
  }
  .navbar-brand {
    margin-right: 3rem;
  }
  .container {
    position: relative;
    z-index: 10;
  }
  .image-zoom {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: all 2s;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    height: 100%;
    width: 100%;
    margin: 0;
    background-color: transparent;
    transform: scale(1) translate(0%, 0%);
    -webkit-transform: translate3d(0, 0, 0);
    /* filter: blur(10px); */
    /* background-color: #000;*/
  }
  .zoomBackOut {
    background-position: 0%;
    /* transform: scale(1.1) translate(1%, 0%); */
    /* filter: blur(2px); */
  }
  .zoomBack {
    background-position: 50% 50%;
    /* filter: blur(0px); */
  }

  .jumbotron {
    position: relative;
    overflow: hidden;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    min-height: calc(100vh);
    margin: 0;
    background-color: transparent;
  }

  .side-description {
    transition: background-size 0.5s 1s cubic-bezier(0.075, 0.82, 0.165, 1);
    position: relative;

    z-index: 1;
    text-align: left;
    background: linear-gradient(rgba(255, 255, 255, 1) 5px, transparent 0);
    background-position: 0px 0px;
    background-size: 0em 5px;
    background-repeat: no-repeat;
    margin-top: 3em;
    color: #fff;
    &.wide-80 {
      width: 80%;
      // right: 5em;
    }

    h1 {
      font-size: 5.5rem;
      font-weight: 200;
      padding: 0.5em 0 0 0;
      margin: 0;
      /* text-shadow: 1px 2px 3px rgba(0, 0, 0, 0.2); */
      font-family: 'IBM Plex Sans Condensed', sans-serif;
    }
    h2 {
      font-size: 4.5rem;
      font-weight: 100;
      padding: 0;
      margin: -.1em 0 1em 0;
      /* text-shadow: 1px 2px 3px rgba(0, 0, 0, 0.2); */
      font-family: 'IBM Plex Sans Condensed', sans-serif;
    }
    span {
      width: 50%;
      display: inline-block;
      /* text-shadow: 1px 2px 3px rgba(0, 0, 0, 0.2); */
    }
  }
  .fadein {
   opacity: 1;
   transition: opacity .25s ease-in-out;
   }
   .fadeout {
   opacity: 0;
   transition: opacity .25s ease-in-out;
   }

  .cover {
    object-fit: cover;
  }
  .headerLineIn {
    background-size: 5em 5px;
  }
  .headerLineOut {
    background-size: 0em 5px;
  }
  &.theme-dark {
    background-color: rgba(33, 35, 37, 1);
    .side-description {
      background: linear-gradient(rgba(255, 255, 255, 1) 5px, transparent 0);
      background-position: 0px 0px;
      background-size: 5em 5px;
      background-repeat: no-repeat;
      color: rgba(255, 255, 255, 1);
    }
    a {
      color: #99E6FC;
    }

  }
  .bg-image {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    background-size: cover;
    background-position: center center;
    background-position-x: 82%;
    background-repeat: no-repeat;
  }

  img {
    max-width: 100%;
    position: relative;
    vertical-align: middle;
  }

  figure {
    margin: 2rem 0;
  }

  figcaption {
    font-size: 80%;
  }

  table {
    width: 100%;
    font-size: 85%;
    border-collapse: collapse;
  }

  /* override slick gallery */
  .slick-slider {
    /* height: 100vh; */
    background: #000;
    .slick-prev,
    .slick-next,
    .slick-dots {
      z-index: 10;
    }
    .slick-prev {
      left: 25px;
    }
    .slick-next {
      right: 100px;
    }
    .slick-dots {
      bottom: 25px;
    }
@media  (max-width: 991.98px) {
      .slick-prev {
        left: 10px;
      }
      .slick-next {
        right: 16px;
      }
    }
    .slick-dots li button:before {
      opacity: 0.8;
      color: #fff;
      text-shadow: #000;
    }
    .slick-dots li.slick-active button {
      background: rgba(255, 255, 255, 0.1) !important;
      border-radius: 50%;
      :before {
        opacity: 1;
        color: #fff;
      }
    }
  }

`
